
































































































































































































































































import ReportModel from "@/model/Report";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import BaseCurrency from "@/components/Base/Controls/BaseCurrency.vue";
import BaseInput from "@/components/Base/Controls/BaseInput.vue";
import { namespace } from "vuex-class";

const AppStore = namespace("App");
const FormStore = namespace("Form");

@Component({
  components: {
    BaseCurrency,
    BaseInput
  }
})
export default class ReportHCP extends Vue {
  @Prop({ required: true })
  readonly value!: ReportModel;

  @FormStore.State
  formDisabled!: boolean;

  private report: ReportModel | null = this.value;

  @AppStore.State
  public reportYear!: number;

  @Watch("value") setValue(newValue: ReportModel) {
    this.report = newValue;
  }

  created() {
    this.report = this.value;
  }

  touch(validator: any) {
    validator && validator.$touch && validator.$touch();
  }
}
